const axios = require('axios');
import apiUrl from '../../api.config';

const STUDENT_GROUP_API_URL = `${apiUrl}studentGroup`;

const StudentGroupService = {
    getGroupByTeacher(){
        return axios.get(STUDENT_GROUP_API_URL + '/getByTeacher', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    add(studentGroupData) {
        return axios.post(STUDENT_GROUP_API_URL + '/add', studentGroupData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    update( studentGroupData) {
        return axios.post(STUDENT_GROUP_API_URL + '/update' , studentGroupData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    delete(groupId) {
        return axios.delete(STUDENT_GROUP_API_URL + '/delete/' + groupId, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
}

export default StudentGroupService;